var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "w-menu-item",
        class: {
          focus: _vm.isFocused,
          active: _vm.isActive,
          disabled: _vm.disabled,
        },
        attrs: { href: _vm.href },
      },
      _vm.listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }